/**
 * @generated SignedSource<<139c2e4e111b57dde4d7dd803ba3be26>>
 * @relayHash e80b0a4466bb973c579a3be7e724aa26
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 10c26fee5a185705c6edc1cc504465a821bef8424513beeb6f40b39691874f32

import type { ConcreteRequest, Query } from 'relay-runtime';
export type OnboardingWizardInnerPermissionsQuery$variables = {
  cloudId: string;
  skipDelegatedAdminCheck: boolean;
};
export type OnboardingWizardInnerPermissionsQuery$data = {
  readonly jira?: {
    readonly canManageCustomOnboarding: boolean | null | undefined;
  } | null | undefined;
};
export type OnboardingWizardInnerPermissionsQuery = {
  response: OnboardingWizardInnerPermissionsQuery$data;
  variables: OnboardingWizardInnerPermissionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipDelegatedAdminCheck"
  }
],
v1 = [
  {
    "condition": "skipDelegatedAdminCheck",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "canManageCustomOnboarding",
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Literal",
                "name": "key",
                "value": "MANAGE_CUSTOM_ONBOARDING"
              }
            ],
            "kind": "ScalarField",
            "name": "hasGlobalPermission"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "OnboardingWizardInnerPermissionsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OnboardingWizardInnerPermissionsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "10c26fee5a185705c6edc1cc504465a821bef8424513beeb6f40b39691874f32",
    "metadata": {},
    "name": "OnboardingWizardInnerPermissionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4a25465480268eec81b6f5dc0fde9fca";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
